import Information from './src/main'

Information.install = function (Vue) {
    Vue.components(Information.name, Information)
}

export default Information